import type { ChatColorTheme } from '@oneToOne/shared/components/chat/theme/ChatThemeContext'
import { HEADER_HEIGHT } from '@oneToOne/shared/components/Header/constants'
import { css } from 'twind/css'

export const headerContainer = ({
  theme,
  transparent,
}: {
  theme: ChatColorTheme
  transparent: boolean
}) =>
  css({
    color: theme === 'light' ? 'var(--blk4)' : '#cbd2d9',
    background: transparent
      ? 'transparent'
      : theme === 'light'
        ? 'rgba(255,255,255,0.7)'
        : 'rgba(27,36,45, 0.7)',
    backdropFilter: transparent ? undefined : 'blur(15px)',
    height: `${HEADER_HEIGHT}px`,
    padding: '8px 12px 0 12px',
  })
